<template>
  <el-container class="PersonnelVehicleInformation">
    <!-- 人口信息 -->
    <el-card class="tree-card" :body-style="treeCard">
      <el-input
        v-model="filterText"
        placeholder="请输入关键词"
        class="input-with-select"
      >
        <template #prefix>
          <i class="iconfont icon-31sousuo"></i>
        </template>
      </el-input>
      <div class="tree-box">
        <el-tree
          :data="dataSource"
          node-key="id"
          highlight-current
          :props="{ label: 'name' }"
          :default-expanded-keys="[rootNodeKey]"
          @current-change="currentChange"
          :expand-on-click-node="true"
          :filter-node-method="filterNode"
        >
        </el-tree>
      </div>
    </el-card>
    <el-card class="tabs-card">
      <el-form
        :inline="true"
        ref="formRef"
        :model="tableParams"
        class="demo-form-inline"
      >
        <el-form-item label="姓名" prop="name">
          <el-input
            clearable
            v-model="tableParams.name"
            placeholder="姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-select clearable v-model="tableParams.sex" placeholder="性别">
            <el-option
              v-for="(item, index) in sexList"
              :key="index"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="民族" prop="nation">
          <el-select clearable v-model="tableParams.nation" placeholder="民族">
            <el-option
              v-for="(item, index) in nationTypeList"
              :key="index"
              :label="item.value"
              :value="item.code"
            ></el-option>
            <!-- <el-option label="蒙古族" value="1"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item label="年龄" prop="ageType">
          <el-select clearable v-model="tableParams.ageType" placeholder="年龄">
            <el-option
              v-for="(item, index) in ageList"
              :key="index"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号" prop="telphone">
          <el-input
            clearable
            v-model.number="tableParams.telphone"
            type="number"
            placeholder="手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="人员标签" prop="label">
          <h-selectcode
            type="prison_label"
            v-model="tableParams.label"
            placeholder="人员标签"
          ></h-selectcode>
        </el-form-item>
        <el-form-item>
          <h-button type="primary" @click="refreshTable">查询</h-button>
          <h-button @click="resetForm(formRef)">重置</h-button>
        </el-form-item>
        <el-row>
          <el-col>
            <h-button type="primary" @click="addButton">添加</h-button>
            <h-button type="danger" @click="delUser">删除</h-button>
            <h-button type="primary" @click="exporting">导出当前页</h-button>
            <h-button type="primary" @click="uploade">导入</h-button>
            <h-button type="primary" @click="exportingAll">导出全部</h-button>
            <h-button type="primary" @click="download">模板下载</h-button>
            <input type="file" v-show="false" ref="file" @change="myup" />
            <!-- <el-upload
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              multiple
              :limit="3"
              :on-exceed="handleExceed"
              :file-list="fileList"
            >
              <el-button type="primary">导入</el-button>
              <template #tip>
                <div class="el-upload__tip">
                  jpg/png files with a size less than 500kb
                </div>
              </template>
            </el-upload> -->

            <!-- <el-popconfirm
              title="1.使用模板的格式添加数据 2.文件大小不能超过20MB"
              @confirm="Import"
            >
              <template #reference>
                <h-button type="primary">导入</h-button>
              </template>
            </el-popconfirm>
            <h-button type="primary" @click="derive">导出</h-button> -->
            <!-- <el-upload
              ref="uploadRef"
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              :auto-upload="false"
            >
              <template #trigger>
                <el-button type="primary">导入</el-button>
              </template>
              <el-button class="ml-3" type="success" @click="submitUpload"
                >导出</el-button
              >
            </el-upload> -->
            <el-alert
              title="请先下载专用模板后上传"
              type="error"
              v-show="flag"
              closable="false"
            />
          </el-col>
        </el-row>
      </el-form>
      <div class="table-box">
        <h-table
          ref="tableRef"
          v-model:data="tableData"
          v-model:columns="columns"
          :method="queryUserList"
          :params="tableParams"
          @handleClick="handleClick"
          @select="hzTableSelect"
        >
          <template #role="{ row }">
            <div class="table-role" @click="clickTable(row)">
              <span>{{ row.name }}</span>
            </div>
          </template>
        </h-table>
      </div>
    </el-card>
    <el-dialog
      v-model="formVisible"
      :title="
        '人口' +
        (formStatus === 1 ? '新增' : formStatus === 2 ? '编辑' : '详情')
      "
      width="800px"
    >
      <personnel-detail
        v-if="formVisible"
        v-model="formVisible"
        :form="userFormData"
        :status="formStatus"
        @submit="userSubmit"
      ></personnel-detail>
    </el-dialog>
  </el-container>
</template>
<script>
import fileDownload from "js-file-download";
import {
  defineComponent,
  nextTick,
  reactive,
  toRefs,
  ref,
  getCurrentInstance,
} from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { getDict } from "@/api/constant";
import axios from "axios";
import {
  queryUserList,
  deleteQuery,
} from "@/api/realPopulation/realPopulation";
import {
  getMenutree,
  uploading,
  downloading,
  deriveing,
} from "@/api/system/region.js";
import _ from "lodash";
export default defineComponent({
  name: "PersonnelVehicleInformation",
  components: {},
  props: {},
  setup(props) {
    const { ctx } = getCurrentInstance();
    const state = reactive({
      filterText: "",
      rootNodeKey: "",
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      flag: false,
      dataSource: [],
      userFormData: {},
      tableParams: {
        name: "",
        sex: "",
        cardNumber: "",
        nation: "",
        telphone: "",
        age: "",
        regionId: 1,
      },
      ageList: [
        // { label: '不限', value: '0' },
        // { label: '0~16', value: '1' },
        // { label: '17~40', value: '2' },
        // { label: '41~60', value: '3' },
        // { label: '61~80', value: '4' },
        // { label: '81以上', value: '5' }
      ],
      tableData: [],
      sexList: [],
      nationTypeList: [],
      // ageList: [],
      formStatus: 1, // 1 添加  2 编辑
      formVisible: false,
      nameVisible: false,
      columns: [
        { type: "selection" },
        {
          label: "姓名",
          hidden: true,
          slot: "role",
          // prop: "name"
        },
        {
          label: "性别",
          prop: "sexDict", // sex
        },
        {
          label: "证件号码",
          prop: "cardNumber",
        },
        {
          label: "民族",
          prop: "nationDict", // nation
        },
        {
          label: "居住地址",
          prop: "houseAddress",
        },
        {
          label: "电话",
          prop: "telphone",
        },
        {
          label: "人员标签",
          prop: "labelDict",
        },
        {
          label: "更新时间",
          prop: "updateTime",
        },
        {
          type: "operate",
          label: "操作",
          width: "140px",
          operates: [
            { name: "编辑", emitKey: "edit" },
            { name: "删除", emitKey: "del", type: "danger" },
          ],
        },
      ],
      // queryUserList: [
      // ]
    });
    const file = ref();
    const refData = toRefs(state);
    const tableRef = ref(null);
    const formRef = ref(null);
    const error = ref();
    const uploadRef = ref();
    // 对组织树节点进行筛选时执行的方法W
    const filterNode = (value, data, node) => {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    };
    // 当前选中节点变化时触发的事件
    const currentChange = (item, nodes) => {
      state.currentNode = item;
      // state.tableParams.deptId = item.deptId;
      state.tableParams.regionId = item.id;
      nextTick(() => {
        tableRef.value && tableRef.value.refresh();
      });
    };
    // 获取结构树
    const queryOrganTreAsync = async () => {
      const result = await getMenutree();
      const treeData = [result.data];
      state.dataSource = treeData;
      if (treeData[0]) {
        currentChange(treeData[0]);
        nextTick(() => {
          state.rootNodeKey = state.currentNode.id;
        });
        state.rootNodeKey = treeData[0].children[0].id;
      }
    };
    // 导入
    const uploade = () => {
      file.value.click();
    };
    const myup = async (e) => {
      var file = e.target.files[0];
      // console.log(files, 123);
      const param = new FormData(); // 创建form对象
      param.append("file", file); // 通过append向form对象添加数据
      param.append("chunk", "0"); // 添加form表单中其他数据

      if (file.name.split(".")[1].toString() !== "xlsx") {
        state.flag = true;
      } else {
        const result = await uploading(param);
        if (result.code == 0) {
          refreshTable();
          ElMessage({
            type: "success",
            message: "上传成功",
          });
        }
      }
    };
    const changeflag = () => {
      state.flag = false;
    };
    // 下载模板
    const download = async () => {
      window.open(window.xlsxUrl + "实有人口信息导入模板.xlsx");
    };

    // 导出
    const exporting = async () => {
      const params = {
        page: 1,
        limit: 20,
      };
      const res = await deriveing(params);
      console.log(res);
      const fileName = `${+new Date()}.xls`;
      const blob = new Blob([res], {
        type: "c",
      });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
      }
    };

    // 导出全部
    const exportingAll = async () => {
      const params = {
        allowpage: true,
      };
      const res = await deriveing(params);
      console.log(res);
      const fileName = `${+new Date()}.xls`;
      const blob = new Blob([res], {
        type: "application/vnd.ms-excel;charset=utf-8",
      });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
      }
    };
    queryOrganTreAsync();
    // 点击查询按钮
    const refreshTable = () => {
      // this.$refs.table.refresh()
      console.log(state.tableParams);
      tableRef.value && tableRef.value.refresh();
    };
    // 重置表单
    const resetForm = (formEl) => {
      if (!formEl) return;
      formEl.resetFields();
    };
    // 表单提交
    const userSubmit = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 点击table操作按钮
    const handleClick = (operate, row) => {
      const { emitKey } = operate;
      if (emitKey === "edit") {
        // 编辑
        state.formStatus = 2; // 把表单设置为编辑状态
        state.userFormData = _.cloneDeep(row);
        state.formVisible = true;
      } else if (emitKey === "info") {
        // 详情
        state.formStatus = 3; // 把表单设置为查看状态
        state.userFormData = _.cloneDeep(row);
        state.formVisible = true;
      } else if (emitKey === "del") {
        ElMessageBox.confirm("您确认要删除该人口信息吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          () => {
            deleteUserAsync([row.prisonId]);
          },
          () => {}
        );
      }
    };
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    const hzTableSelect = (selection) => {
      state.tableSelection = selection;
    };
    // 点击添加按钮
    const addButton = () => {
      state.formStatus = 1;
      state.formVisible = true;
    };
    const deleteUserAsync = async (ids) => {
      // const parms = {
      //   prisonIds: ids
      // };
      const res = await deleteQuery(ids);
      if (res.code === 0) {
        refreshTable();
        ElMessage({
          type: "success",
          message: "删除成功",
        });
      }
    };
    // 批量删除用户
    const delUser = () => {
      if (state.tableSelection.length > 0) {
        ElMessageBox.confirm("您确认要删除选择的用户吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          () => {
            const ids = state.tableSelection.map((item) => item.prisonId);
            deleteUserAsync(ids);
            state.tableSelection = [];
          },
          () => {}
        );
      } else {
        ElMessage({
          type: "warning",
          message: "请选择要删除的用户",
        });
      }
    };
    // 获取数据字典
    const queryMenuType = async () => {
      // nationType 民族
      const res = await getDict("sex");
      const nationType = await getDict("nationType");
      const age = await getDict("ageDurationType");

      state.sexList = res.dict;
      state.nationTypeList = nationType.dict;
      state.ageList = age.dict;
    };
    queryMenuType();
    const clickTable = async (item) => {
      state.formStatus = 3;
      state.formVisible = true;
      state.userFormData = _.cloneDeep(item);
    };
    // const Import = () => {
    //   console.log(uploadRef);
    //   console.log("导入");
    // };
    // const submitUpload = () => {
    //   console.log(uploadRef);
    // };
    // const derive = () => {
    //   console.log("导出");
    // };
    return {
      ...refData,
      filterNode,
      currentChange,
      addButton,
      refreshTable,
      resetForm,
      delUser,
      hzTableSelect,
      handleClick,
      queryUserList,
      userSubmit,
      tableRef,
      formRef,
      clickTable,
      ...toRefs(state),
      uploade,
      file,
      myup,
      error,
      changeflag,
      download,
      exporting,
      exportingAll,
    };
  },
});
</script>
<style lang="scss" scoped>
.PersonnelVehicleInformation {
  .tree-card {
    height: 100%;
    width: 300px;
    .input-with-select {
      margin-bottom: 10px;
    }
    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;
      .tree-header {
        position: sticky;
        top: 0;
        z-index: 2;
        padding: 10px 0;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
        @include flex-row-sb-c;
        .tree-name {
          flex: 1;
          margin-right: 10px;
          padding-left: 48px;
        }
        .tree-status {
          width: 50px;
        }
      }
    }
  }
  .tabs-card {
    flex: 1;
    margin-left: 10px;
    .tabs-tabel-box {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .table-box {
      flex: 1;
      overflow: hidden;
      .table-role {
        color: #294a7c;
        cursor: pointer;

        // text-align: center;
        span {
          border-bottom: 1px solid;
        }
      }
    }
  }
}
</style>
